const numberOnly = e => {
  if ((e.charCode < 48 || e.charCode > 57) && e.charCode !== 46) e.preventDefault();
};

export default {
  name: 'number-only',
  bind(el) {
    el.addEventListener('keypress', numberOnly);
  },
  unbind(el) {
    el.removeEventListener('keypress', numberOnly);
  }
};
